import { AsyncPipe, isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, PLATFORM_ID } from '@angular/core';
import { map, Observable } from 'rxjs';
import { VideoService } from 'src/app/@domain/video/application/video.service';
import { UserService } from '../../../../../../@domain/user/application/user.service';
import { VideoInfo } from '../../../../../../@generated';
import { SpinnerComponent } from '../../../../global/spinner/spinner.component';
import { CardGridComponent } from '../../../card-grid/card-grid.component';
import { VideoItemComponent } from '../../video-item/video-item.component';

@Component({
    selector: 'app-latest-videos',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [VideoItemComponent, SpinnerComponent, AsyncPipe, CardGridComponent],
    styles: `
        :host {
            display: block;
            width: 100%;
        }
    `,
    template: `
        @if (videos$ | async; as videos) {
            <app-card-grid [listView]="false" [mobileHorizontalScroll]="true">
                @for (video of videos; track video.id) {
                    <app-video-item [video]="video" [part]="video.parts[0]" [priorityImageLoading]="isPlatformBrowser && !isAuth()"/>
                }
            </app-card-grid>
        } @else {
            <app-spinner/>
        }
    `
})
export class LatestVideosComponent {
    private userService = inject(UserService);
    private platformId = inject(PLATFORM_ID);

    public videos$: Observable<VideoInfo[]>;
    public isAuth = this.userService.isAuthenticated;
    public isPlatformBrowser = isPlatformBrowser(this.platformId);

    constructor(videoService: VideoService) {
        this.videos$ = videoService.getLatestVideos().pipe(
            map(({ results }) => results ?? [])
        );
    }

}
